import * as CONFIG from '../../../config'

export const fms_sso_path = CONFIG.APP_CONFIG.FMS_V3_SSO_API_GATEWAY
export const headers = {
    'Accept': '*/*',
    'Content-Type': 'application/json; charset=utf-8'
}